import React from 'react';
import "@/scss/_article.scss";

const ArticleKeyTakaway = ({ keyTakeaways }) => {
    return (
        <div className="key-takeaways">
            <h3 className="takeaways-title">Key Takeaways</h3>
            <ul className="takeaways-list">
                {keyTakeaways}
            </ul>
        </div>
    );
};

export default ArticleKeyTakaway;